import { CircleCheckIcon, ClockIcon } from "lucide-react-native";

import { CoverageEventsFlowStepWrapper } from "@/blocks/CoverageEventsFlowStepWrapper";
import { InfoCard } from "@/blocks/InfoCard";
import { WorkRequirementsTitle } from "@/blocks/WorkRequirementsTitle";
import { VnBox } from "@/components/VnBox";
import { VnIcon } from "@/components/VnIcon";
import { VnLink } from "@/components/VnLink";
import { VnLoadingSpinner } from "@/components/VnLoadingSpinner";
import { VnText } from "@/components/VnText/VnText";
import { useWorkRequirementScreeningStep } from "@/hooks/useWorkRequirementScreeningStep";
import { formatLongDate } from "@/utils/date";

export const WorkRequirementConfirmationScreen = () => {
  const { workRequirement, isLoading, goBack } =
    useWorkRequirementScreeningStep();

  // Members short on hours only get the volunteer offramp, so once every proof
  // is uploaded there is nothing left for the household to do.
  const isCompleted = workRequirement?.progress === "COMPLETED";

  return (
    <CoverageEventsFlowStepWrapper onBack={goBack} shouldShowNextButton={false}>
      {isLoading || !workRequirement ? (
        <VnLoadingSpinner />
      ) : (
        <VnBox className="items-center">
          <VnBox className="rounded-full bg-black/5 p-4">
            <VnIcon
              as={isCompleted ? CircleCheckIcon : ClockIcon}
              size={28}
              strokeWidth={1.5}
            />
          </VnBox>

          {isCompleted ? (
            <>
              <WorkRequirementsTitle
                rule={workRequirement.rule}
                variant="headerOne"
                className="mt-4 text-center leading-5"
                i18nKey="native:workRequirements.confirmation.completedTitle"
              />
              <VnText
                variant="lg"
                className="text-muted-foreground mt-6 text-center"
                i18nKey="native:workRequirements.confirmation.completedDescription"
              />
            </>
          ) : (
            <>
              <WorkRequirementsTitle
                rule={workRequirement.rule}
                variant="headerOne"
                className="mt-4 text-center"
                i18nKey="native:workRequirements.confirmation.title"
              />
              <VnText
                variant="lg"
                className="text-muted-foreground mt-3 text-center"
                i18nKey="native:workRequirements.confirmation.description"
                i18nOptions={{
                  date: formatLongDate(workRequirement.workRequirementDate),
                }}
              />

              <InfoCard
                className="bg-card mt-6 w-full"
                titleI18nKey="native:workRequirements.confirmation.uploadsHint"
              />
            </>
          )}

          <VnLink
            href={{ pathname: "/(authed)" }}
            i18nKey="common:returnToDashboard"
            renderAsButton
            className="mt-8 w-full"
          />
        </VnBox>
      )}
    </CoverageEventsFlowStepWrapper>
  );
};
